import styled from 'styled-components';

export const ChartsBoxStyles = styled.div`
  .head {
    position: relative;
    flex: none;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: nowrap;
    /* padding: 10px; */
    padding: 16px 24px 4px 24px;
    height: 40px;
    /* padding: 1.6rem 2.4rem 0.4rem 2.4rem; */
    background-color: white;
    border-radius: 4px;
    color: #212121;
    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: nowrap;
      width: 100%;
      height: 16px;
      line-height: 16px;

      .title_m {
        font-size: 16px;
        word-break: keep-all;
        /* font-weight: 900; */
        /* line-height: 8px; */
        /* color: #666; */
        /* margin-top: -6px; */
      }

      .title_r {
        flex: 1;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .contentBox {
    height: calc(100% - 40px) !important;
  }
  .bodyContent {
    border-radius: 4px;
    background: ${(props) => props.theme[props.brand].chartBox.contentBgColor};
    /* flex: 1; */
    /* padding: 10px; */
    /* padding: 0 1.2rem 0.8rem 1.2rem; */
    padding: 0 24px 16px 24px;
    height: 100%;
    min-height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
